import { Grid } from '@postenbring/hedwig-react';
import { OperationReport as OperationReportComponent } from '../../components/OperationReport';

export const OperationReport = ({ heading, publishDate, language, utext }) => (
    <Grid span={{ initial: 12, large: 9 }}>
        <OperationReportComponent heading={heading} publishDate={publishDate} language={language} utext={utext} />
    </Grid>
)
